import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-range-exceed-error',
    standalone: true,
    template: ` <p class="flex items-center mt-1" style="white-space: normal;">
        The document has {{ max }} pages, please remove pages above
        {{ max }}
    </p>`,
})
export class PageRangeExceedErrorComponent {
    @Input() max: number | null = null;
}
